<template>
  <a-modal
    :title="audit ? '用车审批' : '用车详情'"
    class="gufiiguy"
    :visible="is_show"
    style="top: 20px"
    :width="1000"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
  >
    <template slot="footer">
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="抄送人"
                style="text-align: left"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.ccName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="实际用车部门">
                <span>{{ mdl.deptUseName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="司机预约">
                <span>{{ driverType[mdl.isDriver].label }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="预计出行日期">
                <span>{{ mdl.goToDate }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="预计回程日期">
                <span>{{ mdl.goBackDate }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="预计用车时长(天)">
                <span>{{ mdl.days }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.remark }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>用车明细</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="用车人">
                <span>{{ mdl.carUser }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="同行人	">
                <span>{{ mdl.peer }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="车辆属性">
                <span>{{ carMap2[mdl.carTypes] }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="车牌号码">
                <span>{{ mdl.plateNumber }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if="mdl.carTypes == 0">
              <a-form-model-item label="最新里程数">
                <span>{{ mdl.latestMileage }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="用车事由" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.carReason }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="出差地(具体到区)" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.prefecture }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit  && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
      </a-form-model>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal2 ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <payMentModal2 ref="paymentmodal" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <transferModal ref="transferModal" @sure="handleSure" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
  </a-modal>
</template>
<script>
import auditModel from './audit.vue'
import { download_file_java } from '@/utils/request'
import { getCarApply, auditTask, act_task_audit, reimburse_apply_downlodPdf, modalMap } from '@/api/activiti'
import { getDeptListEnable2 } from '@/api/system'
import preview from '@/components/module/prview'

import BusinessModal from '@/views/activiti/modules/BusinessModal.vue'
import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
import ScrapModal from '@/views/activiti/modules/ScrapModal.vue'
import receiveModal from '@/views/activiti/modules/receiveModal.vue'
import OperationModal from '@/views/activiti/modules/OperationModal.vue'
import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
import ReimbursementModal2 from '@/views/activiti/modules/ReimbursementModal2.vue'
import payMentModal2 from '@/views/activiti/modules/payMentModal2.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import Watermark from '../../../utils/watermark'
const deptMap = {}
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal2,
    payMentModal2,
    contractModal,
    transferModal,
    sealModal,
    currencyModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      deptTree: [],
      deptMap,
      visible: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      form: this.$form.createForm(this),
      is_show: false,
      record: '',
      timeout: null
    }
  },
  created() {
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        this.deptTree.map((d) => {
          if (d.hasOwnProperty('children')) {
            d.children.map((b) => {
              deptMap[b.key] = {
                text: b.title,
              }
              deptMap[d.key] = {
                text: d.title,
              }
            })
          } else {
            deptMap[d.key] = {
              text: d.title,
            }
          }
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
  },
  methods: {
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    handelAudit(item) {
      const modal = modalMap[item.associateTypes]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    },
    download() {
      reimburse_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
        window.open('http://47.114.172.13:8888/file/download?path=' + res.data)
      })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    }, //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    //预览文件
    // previewFile(file) {
    // 	console.log(file)
    // 	window.open(file.preUrl)
    // },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    show(record) {
     this.recordNumber =  record.recordNumber
      this.record = record
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      getCarApply(record.businessKey).then((res) => {
        if (res.code === 200) {
          const { type } = res.data
          this.mdl = Object.assign(res.data)
          this.is_show = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
             if(!this.audit  && this.recordNumber==1) {
                 this.$refs.auditModel.show(record)
               }
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
        console.log(this.record.procName)
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
           clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //审批
           this.actTask()
         }, 1000)
          // this.actTask()
        }
      } else if (this.result == 2) {
         clearTimeout(this.timeout)
         console.log(this.timeout, 'this.timeout==========================')
          this.timeout = setTimeout(() => {
            //通过审批
           this.actTask()
         }, 1000)
        // this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}

.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
}

.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  margin-left: 10px;
  color: dodgerblue;
  padding: 10px;
}
.textleft {
  text-align: left;
}
// /deep/ .content {
// 	padding-left: 10px  !important;
// }
// /deep/ .ant-form-item-label {
// 	text-align: left;

// }
</style>
